import '@/i18n';
import React from 'react';
import { GetServerSideProps } from 'next';
import { IconName } from '@/components/Atoms/Icon/Icon';
import { getTheme } from 'src/service/engageFrontendGateway';
import { logRequest } from 'utils/consoleLog';
import { ThemeType } from 'types/publishedAssets';
import { SupportedLanguages } from 'types/supportedLanguages';
import { setNoCache } from 'utils/cacheHeaders';
import { InvitationError, errorIconMap } from 'src/components/InvitationError/InvitationError';
import { InvitationErrorType } from 'src/serverUtils/InvitationErrorType';

export { InvitationErrorType };

export const getServerSideProps: GetServerSideProps = async ({ req, params, query, res }) => {
  setNoCache(res);
  logRequest(req);
  const organization = params?.organization as string;
  const locale = params?.locale as string;
  const uuid = params?.engagement as string;
  const errorType = query?.errorType as InvitationErrorType;
  const title = `${errorType}.title`;
  const description = `${errorType}.description`;
  const iconName = errorIconMap[errorType];

  const theme = await getTheme(organization, locale);
  const urlParams = {
    organization,
    locale,
    type: 'engagement',
    uuid,
    errorType,
  };
  return {
    props: {
      theme,
      urlParams,
      title,
      description,
      iconName,
    },
  };
};

export function InvitationErrorPage({
  theme,
  title,
  description,
  iconName,
  urlParams,
}: {
  theme: ThemeType;
  title: string;
  description: string;
  iconName: IconName;
  urlParams: { organization: string; locale: SupportedLanguages; engagement: string; preview: boolean; code: string };
}) {
  return (
    <InvitationError theme={theme} title={title} description={description} iconName={iconName} urlParams={urlParams} />
  );
}

export default InvitationErrorPage;
